import API, { handleRequest } from "./lib/api";

export const sendPinResetOtp = async ({ email }) => {
	const value = email?.trim?.() || "";
	return handleRequest(() =>
		API.post("pin-reset/request", {
			email: value,
		})
	);
};

export const resetPin = async ({
	email,
	otp,
	new_pin,
	new_pin_confirmation,
}) => {
	const value = email?.trim?.() || "";
	return handleRequest(() =>
		API.post("pin-reset/reset", {
			email: value,
			otp: otp?.trim?.() || "",
			new_pin,
			new_pin_confirmation,
		})
	);
};
